<div
  class="container"
  [appTooltip]="title || ''"
  [appTooltipDisabled]="!title || title.length <= 14"
  [ngStyle]="{
    width: width ? (width | scaleByOffice) : undefined,
    height: height ? (height | scaleByOffice) : undefined,
    'pointer-events': disabled ? 'none' : undefined,
    'min-width': width === 'unset' ? (minWidth | scaleByOffice) : undefined,
    'max-width': height === 'unset' ? (maxWidth | scaleByOffice) : undefined,
    padding: padding ? (padding | scaleByOffice) : undefined,
    'border-radius': borderRadius ? (borderRadius | scaleByOffice) : undefined,
    'font-size': fontSize ? (fontSize | scaleByOffice) : undefined
  }"
>
  <ng-container *transloco="let tScreenButton; read: 'office.screenButton'">
    <img
      src="assets/img/icons/screen.svg"
      [ngStyle]="{ width: iconWidth | scaleByOffice, height: iconHeight | scaleByOffice }"
    />
    <div class="title" [ngStyle]="{ 'padding-top': titlePaddingTop | scaleByOffice }">
      {{ title ? title : tScreenButton("screen") }}
    </div>
  </ng-container>
</div>
